import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import getItemFromLocalStorage from 'utils/getItemFromLocalStorage';

const PrivateRoute = ({ component: Component, path }: any) => {
  // Simple client-side validation - no loading state, no API calls
  const user = getItemFromLocalStorage('user');
  
  // If no valid user or token, redirect to login
  if (!user || !user.access) {
    return <Redirect exact to={{ pathname: '/login', state: { from: window.location.pathname } }} />;
  }

  // Render protected component
  const isDynamicRoute = path.includes(':');
  return <Route exact={!isDynamicRoute} path={path} component={Component} />;
};

export default PrivateRoute;